import axios from "axios";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

export const getAutoStation = async (query) => {
  //console.log("GetStationList",`${REACT_APP_API}/api/Reservations/Rail/GetStationList?CityCode=${query}&maxlength=2`)
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Reservations/Rail/GetStationList?CityCode=${query}&maxlength=2`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching city suggestions:", error);
    throw error;
  }
};